import React from 'react'
import PropTypes from 'prop-types'

import { Title60, Eyebrow, Body12 } from 'components/Typography'
import theme from 'styles/theme'
import { Spacing50 } from 'styles/sharedStyle'
import trackGTM from 'utils/trackGTM'
import { PDFListWrapper, PDFListItems, PDFListItem } from './PDFList.style'

const PDFList = ({ eyebrow, headline, items }) => (
  <>
    <Spacing50 />
    <PDFListWrapper>
      <Spacing50 />
      <Eyebrow mb={[theme.space[4]]}>{eyebrow}</Eyebrow>
      <Title60 mb={[theme.space[11]]}>{headline}</Title60>
      <PDFListItems>
        {items.map((item, index) => (
          <PDFListItem
            onClick={() => trackGTM('Downloads', 'Download', 'pdf', item.link)}
            href={item.link}
            target="_blank"
            key={`item-${index.toString()}`}>
            <Body12>{item.text}</Body12>
          </PDFListItem>
        ))}
      </PDFListItems>
      <Spacing50 />
    </PDFListWrapper>
    <Spacing50 />
  </>
)

PDFList.propTypes = {
  eyebrow: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default PDFList
